import React, { useEffect, useState } from 'react'
import { CButton, CCard, CBadge, CCardBody, CCardTitle, CCol, CImage } from '@coreui/react'
import apiClient from '../../services/apiClient'
import { useNavigate } from 'react-router-dom'
import { buildApiUrl } from '../../utils/getConfiguration'

const Activerisks = () => {
  const [recommendations, setRecommendations] = useState([])
  const fetchRecommendationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(
        buildApiUrl('accountRemindersDone', {
          account_ID,
          grp_ID,
        }),
      )

      setRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }
  useEffect(() => {
    fetchRecommendationsData()
  }, [])

  let navigate = useNavigate()
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Active reminders</p>
            </h4>
          </CCol>
          <CCol sm={6}>
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <CButton
                color="primary"
                onClick={() => {
                  //localStorage.removeItem('loginName1')
                  //localStorage.removeItem('wizard')
                  console.log('Cancel')
                  navigate('/dashboard')
                }}
              >
                Cancel
              </CButton>
            </div>
            <div className="small text-medium-emphasis">
              {recommendations.length > 0 && (
                <div>
                  {recommendations.map((recommendation) => (
                    <div key={recommendation.reminder_ID}>
                      {/*{recommendation.reminder_ID === localStorage.getItem('taskid') && (*/}
                      <div key={recommendation.reminder_ID}>
                        <div>
                          <CCard key={1} sm={2} className="mb-4">
                            <CCardBody>
                              <CCol>
                                <CCardTitle>
                                  <CImage
                                    rounded
                                    orientation="top"
                                    src={recommendation.pic}
                                    width={50}
                                    height={50}
                                    onClick={() => {
                                      //console.log('Task Detail ' + recommendation.reminder_ID)
                                      //localStorage.setItem('taskid', recommendation.reminder_ID)
                                      navigate('/risks')
                                    }}
                                  />
                                  <CBadge color="danger" className="ms-2">
                                    HIGH RISK
                                  </CBadge>
                                  - {recommendation.Title}
                                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <CButton
                                      color="primary"
                                      onClick={() => {
                                        console.log('Task Detail ' + recommendation.reminder_ID)
                                        localStorage.setItem('taskid', recommendation.reminder_ID)
                                        navigate('/detail')
                                      }}
                                    >
                                      Detail
                                    </CButton>
                                    <CButton
                                      color="primary"
                                      onClick={() => {
                                        //localStorage.removeItem('loginName1')
                                        //localStorage.removeItem('wizard')
                                        console.log('Task Ignored')
                                        //navigate('/dashboard')
                                      }}
                                    >
                                      Ignore
                                    </CButton>
                                    <CButton
                                      color="primary"
                                      onClick={() => {
                                        console.log('Task Done')
                                        //navigate('/login')
                                      }}
                                    >
                                      Done
                                    </CButton>
                                  </div>
                                </CCardTitle>
                              </CCol>
                            </CCardBody>
                          </CCard>
                          {/*<CRow>
                            <WidgetsDropdown />
                          </CRow>*/}
                        </div>
                      </div>
                      {/*)}*/}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard
      // key={recommendation.reminder_ID}
      // style={{ width: '12rem', height: '25rem' }}
      >
        <CCardBody>
          <CCol sm={12}>
            {/*<CCardImage orientation="top" src={avatar2} />
            <CCardTitle>{recommendation.Title}</CCardTitle>
            <CCardText>{recommendation.Description}</CCardText>*/}
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <CButton
                color="primary"
                onClick={() => {
                  //localStorage.removeItem('loginName1')
                  //localStorage.removeItem('wizard')
                  console.log('Cancel')
                  navigate('/dashboard')
                }}
              >
                Cancel
              </CButton>
            </div>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Activerisks
